import Navbar from "./components/navbar";
import React, { useEffect, useState } from "react";
import resume_info from "./assets/resumeData.json";
import AboutMe from "./components/aboutMe";
import { CssVarsProvider, useColorScheme, useTheme } from "@mui/joy/styles";
import { Button } from "@mui/joy";
import { BsFillMoonFill, BsFillSunFill } from "react-icons/bs";
import Portrait from "./assets/portrait.png";
import Experience from "./components/experience";
import Education from "./components/education";
import Project from "./components/project";
import Footer from "./components/footer";

function App() {
  const theme = useTheme();

  localStorage.setItem("theme", theme.palette.background.backdrop);

  const ModeToggle = (props) => {
    const { mode, setMode } = useColorScheme();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
      setMounted(true);
    }, []);
    if (!mounted) {
      return null;
    }

    return (
      <Button
        sx={props.sx.toggleStyle}
        size="lg"
        variant="plain"
        onClick={() => {
          if (mode === "light") {
            setMode("dark");
          } else {
            setMode("light");
          }
        }}
      >
        {mode === "light" ? <BsFillMoonFill /> : <BsFillSunFill />}
      </Button>
    );
  };

  const useWindowSize = () => {
    const [winSize, setWinSize] = useState({
      width: undefined,
      height: undefined,
    });

    useEffect(() => {
      const handleResize = () => {
        setWinSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return winSize;
  };

  return (
    <CssVarsProvider>
      <Navbar
        size={useWindowSize()}
        darkModeToggle={ModeToggle}
        social={resume_info.main.social}
        resume_link={require("./assets/Resume.pdf")}
      />
      <AboutMe
        size={useWindowSize()}
        image={Portrait}
        hello={resume_info.main.hello}
        info={resume_info.main}
        id="about-me"
      />
      <Experience
        size={useWindowSize()}
        exp={resume_info.exp}
        id="experience"
      />
      <Education size={useWindowSize()} edu={resume_info.exp} />
      <Project
        size={useWindowSize()}
        proj={resume_info.portfolio}
        assets={resume_info.assets}
        id="projects"
      />
      <Footer size={useWindowSize()} />
    </CssVarsProvider>
  );
}

export default App;
